/**
 * Handles the JavaScript associated with the Global navigation
 */

import scrollEvent from '../../components/fsUtils/scrollEvent';
import Viewports from '../../components/fsUtils/Viewports';
import screenLock from '../../components/fsUtils/screenLock';

class NavGlobal {

    /**
     * Intialize some variables for the Mobile Menu button and scroll positioning.
     * Bind a scroll event listener to the window object and tie it to 'watch' function.
     * Bind a click event listener to the mobile menu element and tie it to 'menuToggler' function.
     *
     * @since 0.1.0
     */
    constructor() {
        this.mobileMenuBtn = document.getElementById('nav-open-btn');
        this.menu = document.getElementById(this.mobileMenuBtn.dataset.target);
        this.bodyClassList = document.body.classList;
        this.header = document.getElementById('header-wrapper');
        this.secondNav = document.querySelector('.section-nav');
        this.globalNav = document.getElementById('global-nav');
        this.globalNavWrapper = document.querySelector('.global-nav-wrapper');
        this.globalNavContainer = document.querySelector('.global-nav-container');
        this.globalNavOverlay = document.getElementById('global-nav-overlay');
        this.globalNavDefault = document.querySelector('#sports-nav .menu-title');

        // the inner menu selectors strings
        let innerMenuStr = `
            #sports-nav > li,
            #watch-nav > li,
            #fantasy-nav > li,
            #more-nav > li,
            #account-nav > li.logged-in,
            #follow-nav > li,
            #shows-nav > li,
            #account-nav #provider-icon
        `;

        this.innerMenu = document.querySelectorAll(innerMenuStr);
        this.mActivator = document.querySelector('.m-nav-activator');
        this.topLevel = document.querySelector('.section-nav .top-level');
        this.navOverflow = document.querySelectorAll('.nav-overflow-more');
        this.throttle = ('ontouchstart' in document.documentElement) ? 50 : 10;
        this.lastScrollTop = 0;
        this.branchBannerHeight = 76;
        this.globalNavHeight = this.globalNavContainer.offsetHeight || 68;
        this.isGlobalNavHidden = false;
        this.bodyTagsAdded = false;
        this.sidebar = document.querySelector('#sidebar');
        this.sidebarClassList = (this.sidebar) ? this.sidebar.classList : null;
        this.branchBanner = document.getElementById('branch-banner-iframe');
        this.isBannerTop = false;
        this.screenLock = new screenLock();
        this.viewport = new Viewports({
            'mobile': 767,
            'desktop': 1024
        });

        this.sportsNavContainer = document.getElementById('sports-nav-container');
        this.sportsNavTopItems = this.sportsNavContainer
            ? this.sportsNavContainer.querySelectorAll('.top-level > li:not(#js-tablet-overflow)')
            : null;
        this.jsTabletOverflowNav = document.getElementById('js-tablet-overflow');
        this.sprotsNavTopSubmenu = document.querySelectorAll('#sports-nav-container .top-level > li:not(#js-tablet-overflow) > .sub-menu');

        this.secondNavHeight = this.secondNav ? this.secondNav.clientHeight : 0;

        this.setupScoreStrip();
        this.initEventListeners();
        this.adjustSportsNav();

        this.isFsgo = document.querySelector('.fsg-header');

        // Adding a flag to the root element so we can hook into the template with CSS
        document.documentElement.className += " js-loaded";


    }

    setupScoreStrip() {
        this.scoreStrip = document.querySelector('#ScorestripContainer');
        if (this.scoreStrip) {
            this.scoreStripHeight = this.scoreStrip.offsetHeight || 75;
        } else {
            document.body.classList.add('no-scorestrip');
        }
        this.scorestripTagsAdded = false;
        this.scoreStripHeight = this.scoreStripHeight || 0;

    }

    initEventListeners() {

        // Only bind the listener if the header exists.
        if (null !== this.header) {
            // bind "pin on scroll"
            this.watch = this.watch.bind(this);
            this.watch = scrollEvent.throttle(this.watch, this.throttle);
            window.addEventListener('scroll', this.watch.bind(this));

            // bind "define offset on resize"
            this.watchResize = this.watchResize.bind(this);
            this.watchResize = scrollEvent.throttle(this.watchResize, this.throttle);
            window.addEventListener('resize', this.watchResize.bind(this));


            // Only bind the listener if the mobile menu exists.
            if (null !== this.mobileMenuBtn) {
                this.mobileMenuBtn.addEventListener('click', () => this.menuToggler());
            }

            // Only bind the listener if an inner menu exists.
            if (this.innerMenu.length > 0) {
                for(let i = 0, count = this.innerMenu.length; i < count; i++) {
                    let menu = this.innerMenu[i];
                    if(menu) {
                        //mouse event for hover on desktop
                        menu.addEventListener('mouseover', (e) => this.innerMenuToggler(menu, e));                    
                        menu.addEventListener('mouseleave', (e) => this.onMenuLeave(menu, e));
                        //mouse event for click on desktop, mobile and ipad
                        menu.addEventListener('click', (e) => this.innerMenuToggler(menu, e));
                    }
                }
            }

            // Only bind the listener if an overflow menu links exists.
            if (this.navOverflow.length > 0) {
                for(let i = 0, count = this.navOverflow.length; i < count; i++) {
                    let link = this.navOverflow[i];
                    if(link) {
                        link.addEventListener('click', (e) => this.navOverflowToggler(e));
                    }
                }
            }

            if (this.sportsNavContainer) {
                this.sportsNavContainer.addEventListener('mouseover', this.onSportsNavOver);
            }
        }

    }
    /**
     * Handle toggling classes on the body, mobile menu button and mobile menu
     * for CSS styling and visibility when the menu is toggled on smaller screens.
     *
     * @since 0.1.0
     */
    menuToggler() {
        /**
         * If the mobile menu has the class 'active', remove it from the mobile menu,
         * the mobile menu toggle and remove the body tag class 'global-menu-open'.
         */
        if (this.bodyClassList.contains('global-menu-open') || this.bodyClassList.contains('section-nav-open')) {
            this.closeMenu();
            // Otherwise, set these elements to their active classes.
        } else {
            this.openMenu();
        }
    }
    closeMenu() {
        this.globalNavContainerTopPos = this.globalNavContainer.getBoundingClientRect().top || 0;
        if (this.viewport.getViewPort() === 'tablet' || this.bodyClassList.contains('branch-banner-is-active')) {
            this.globalNavWrapper.style.top = null;
        }
        this.mobileMenuBtn.classList.remove('active');
        this.menu.classList.remove('active');
        this.globalNavOverlay.classList.remove('show');
        this.globalNavWrapper.classList.remove('show');
        this.globalNavDefault.classList.remove('active');
        this.bodyClassList.remove('global-menu-open');
        this.screenLock.unlockScreen();

        return this;
    }
    openMenu() {
            if(this.branchBanner === null) {
                this.branchBanner = document.getElementById('branch-banner-iframe');
                //check if the banner is on the top.
                if(this.branchBanner && !this.isBannerTop && this.branchBanner.style.cssText.indexOf( 'top' ) > -1 ) {
                    this.isBannerTop = true;
                }   
            }
            //if banner is on the top, we want to scroll pass it, otherwise skip.
            if (this.bodyClassList.contains('branch-banner-is-active') && window.pageYOffset <= this.branchBannerHeight && this.isBannerTop) {
                window.scrollTo(0, this.branchBannerHeight);
            }
            this.globalNavContainerTopPos = this.globalNavContainer.getBoundingClientRect().top || 0;
            this.mobileMenuBtn.classList.add('active');
            this.menu.classList.add('active');
            this.globalNavOverlay.classList.add('show');
            this.globalNavWrapper.classList.add('show');
            // When opening the menu, always reset to sports menu
            for(let i = 0, count = this.innerMenu.length; i < count; i++) {
                let item = this.innerMenu[i];
                if(item) {
                    item.classList.remove('active');
                }
            }
            this.globalNavDefault.classList.add('active');
            this.bodyClassList.add('global-menu-open');
            this.setGlobalNavWrapperHeight();
            this.screenLock.lockScreen();
            //close second nav if opened
            if (this.bodyClassList.contains('section-menu-open')) {
                this.mActivator.classList.remove('is-active');
                this.topLevel.classList.remove('is-active');
                this.bodyClassList.remove('section-menu-open');
            }
            if (this.bodyClassList.contains('scorestrip-open')) {
                if (window.scoreStrip) window.scoreStrip.minimize();
                this.bodyClassList.remove('scorestrip-open');
            }
            return this;
        }
        /**
         * Handle Adding/Removing 'active' from the inner menu item
         * effectively toggling a menu section's visibility.
         */
    innerMenuToggler(targetMenu, e) {
        /**
         * handle click event toggling on primary sub menus links on ipad
         * we need to add preventDefault on the links; otherwise, the drop down menu won't show on click/tap
         * instead it goes to href target url, and only apply preventDefault if there is subnav, meaning there is
         * <ul> tag next to <a> tag
         */
        let targetIsOverflowItem = e.target.parentElement.parentElement.parentElement.classList.contains('nav-overflow');
        if (e.type === "click" && this.checkIfTablet() && e.target.tagName.toLowerCase() === "a" && e.target.nextSibling && !targetIsOverflowItem) {
            e.preventDefault();
            let targetSubMenu = e.target.parentNode.querySelector('ul.sub-menu');
            for(let i = 0, count = this.innerMenu.length; i < count; i++) {
                let menu = this.innerMenu[i];
                let subMenus = menu.querySelectorAll('ul.sub-menu');
                for(let j = 0, cnt = subMenus.length; j < cnt; j++) {
                    let subMenu = subMenus[i];
                    if( subMenu != targetSubMenu ) { 
                        subMenu.classList.remove('ipad-hidden','ipad-visible'); 
                    }
                }
            }

            this.toggleIpadMenuVisibility( targetSubMenu );
        }
        for(let i = 0, count = this.innerMenu.length; i < count; i++) {
            let menu = this.innerMenu[i];
            if( menu != targetMenu ) menu.classList.remove('active');
        }
        targetMenu.classList.add('active');
    }

    /**
     * Handle on sports nav over
     * @param e
     */
    onSportsNavOver(e) {
        if (window.innerWidth < 1024) return;
        if (!e || !e.target) return;

        let target = e.target;
        let submenu = target.tagName === 'LI' ? target.querySelector('.sub-menu') : target.parentElement.querySelector('.sub-menu');

        if (!submenu || !submenu.clientWidth) return;

        let rect = submenu.getBoundingClientRect();
        let diff = document.body.clientWidth - (submenu.clientWidth + rect.left);
        let leftStyleValue = parseInt(window.getComputedStyle(submenu, null).getPropertyValue('left'));

        if (diff < 0) {
            submenu.style.left = (leftStyleValue + diff - 10) + 'px';
        }
    }

    /**
     * handle menu leave
     */
    onMenuLeave(targetMenu, e) {
        let width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (width >= 1024) {
            targetMenu.classList.remove('active');
        }
    }
    /**
     * Handle visibility of overflow menu (specific for iPad landscape)
     */
    navOverflowToggler(e) {
        e.preventDefault();

        if( this.checkIfTablet() && e.target.nextSibling ) {
            let targetSubMenu = e.target;
            do {
                targetSubMenu = targetSubMenu.parentNode;
            }
            while(targetSubMenu.querySelector('ul.sub-menu') == null);
            targetSubMenu = targetSubMenu.querySelector('ul.sub-menu');
            for(let i = 0, count = this.innerMenu.length; i < count; i++) {
                let menu = this.innerMenu[i];
                let subMenus = menu.querySelectorAll('ul.sub-menu');
                for(let j = 0, cnt = subMenus.length; j < cnt; j++) {
                    let subMenu = subMenus[i];
                    if( subMenu != targetSubMenu ) subMenu.classList.remove('ipad-hidden','ipad-visible');
                }
            }
            this.toggleIpadMenuVisibility( targetSubMenu );
        }
    }
    /*
        toggle classname for hiding/showing nav menu
        NOTE: made for iPad/tablet viewport only
    */
    toggleIpadMenuVisibility( targetMenu ){

        if( targetMenu.classList.contains('ipad-visible') ){
            targetMenu.classList.remove('ipad-visible');
            targetMenu.classList.add('ipad-hidden');
        } else if ( targetMenu.classList.contains('ipad-hidden') ) {
            targetMenu.classList.remove('ipad-hidden');
            targetMenu.classList.add('ipad-visible');
        } else {
            targetMenu.classList.add('ipad-visible');
        }        
    }

    // stick - stick the navs
    stick() {
            this.globalStick();
            this.secondNavStick();
        }
        // unstick - unstick the navs
    unstick() {
        this.globalUnstick();
        this.secondNavUnstick();
    }
    addAppBannerBodyTags() {
            if (!this.bodyTagsAdded) {
                this.bodyClassList.remove('appBannerDisplayed');
                this.bodyClassList.add('appBannerHidden');
                this.bodyTagsAdded = true;
            }
        }
        // unstick for global nav
    removeAppBannerBodyTags() {
        if (this.bodyTagsAdded && !this.bodyClassList.contains('section-menu-open')) {
            this.bodyClassList.add('appBannerDisplayed');
            this.bodyClassList.remove('appBannerHidden');
            this.bodyTagsAdded = false;
        }
    }
    hideGlobalNav() {
        if (!this.isGlobalNavHidden) {
            //this.header.style.top = -this.globalNavHeight + 'px';
            this.header.classList.add('push-up');
            this.isGlobalNavHidden = true;
        }
    }
    showGlobalNav() {
        if (this.isGlobalNavHidden) {
            this.header.classList.remove('push-up');
            this.isGlobalNavHidden = false;
        }
    }
    setGlobalNavWrapperHeight() {
        let offsetHeight = (window.innerHeight - 40);
        //checl if orientation is landscapte == 0 is portrait
        if(window.orientation !== 0 ) {
            let menuHeight = (58 * this.menu.childElementCount);
            if(menuHeight > window.innerHeight) {
                offsetHeight = menuHeight;
            }
            this.globalNavWrapper.style.height = offsetHeight + 'px';
        }
      
        this.globalNavWrapper.style.height = (window.innerHeight - 40) + 'px';

    }
    removeAllBodyClasses() {
        if (this.viewport.getViewPort() !== 'mobile') {
            if (window.pageYOffset <= this.getYOffset()) {
                if (this.sidebarClassList) this.sidebarClassList.remove('fix');
            }
            if (this.viewport.winW >= 1024 && this.bodyClassList.contains('scorestripHidden')) {
                this.hideGlobalNav()
            } else {
                this.showGlobalNav();
            }
        }
    }
    toggleSticky(stickPoint) {
        let scrollPos = window.pageYOffset || document.documentElement.scrollTop;
        let scorestripPresent = this.bodyClassList.contains('scorestrip-wide');
        if (this.bodyClassList.contains('branch-banner-is-active')) {
            if (scrollPos > stickPoint) {
                this.addAppBannerBodyTags();
            } else {
                this.removeAppBannerBodyTags();
            }
        }
    }

    // getYOffset = get Y offset
    getYOffset() {
        if (this.bodyClassList.contains('branch-banner-is-active')) {
            return this.branchBannerHeight;
        } else {
            return 0;
        }
    }

    checkIfTablet() {
        return (this.viewport.isTouch && 'desktop' === this.viewport.getViewPort());
    }

    toggleHeader(st){

        if( this.isFsgo ) return; 
        
        // Downscroll
        if (st > this.lastScrollTop) { 
            if( st > this.secondNavHeight + this.scoreStripHeight + this.getYOffset() && !this.bodyClassList.contains('scrolled')) {
                this.bodyClassList.add('scrolled');
            }
        } else {
            //upscroll
            if (st < (this.lastScrollTop - 1)) {
                this.bodyClassList.remove('scrolled');
            }
        }
    }

    /**
     * Watch for scrolling changes in direction.
     *
     * @since 0.1.0
     */
    watch() {

            if (this.bodyClassList.contains('global-menu-open') || document.body.classList.contains('scorestrip-open')) return;
            let pinPos = this.getYOffset();

            let st = window.pageYOffset || document.documentElement.scrollTop;
            // Desktop
            if (this.viewport.getViewPort() == 'desktop') {
                // Downscroll
                if (st > this.lastScrollTop) {
                    if (st > pinPos) {
                        this.addAppBannerBodyTags();
                    }
                    // Upscroll
                } else {
                    if (st < (this.lastScrollTop - 1)) {
                        if (st < pinPos) {
                            this.removeAppBannerBodyTags();
                        }
                    }
                }
            } else {
                // Mobile/Tablet
                this.toggleSticky(this.getYOffset());
            }

            this.toggleHeader(st);

            // Update the lastScrollTop value to the page's offset.
            this.lastScrollTop = st;
        }
        /**
         * Watch for resize and orientation change.
         */
    watchResize() {
        this.viewport.setWinW(window.innerWidth);
        this.globalNavHeight = this.globalNavContainer.offsetHeight;
        if (this.globalNavWrapper.classList.contains('show') && this.viewport.winW >= 1024) {
            this.closeMenu();
        } else if (this.globalNavWrapper.classList.contains('show')) {
            this.setGlobalNavWrapperHeight();
        }

        this.adjustSportsNav();

        //removes body tags when resizing
        this.removeAllBodyClasses();
    }

    adjustSportsNav() {
        if (this.viewport.winW < 1024 || this.viewport.winW > 1279) return;
        if (!this.sportsNavContainer || !this.sportsNavTopItems) return;
        if (this.sportsNavTopItems.length < 3 || !this.jsTabletOverflowNav) return;

        let navItems = this.sportsNavContainer.querySelectorAll('.top-level > li:not(#js-tablet-overflow)');
        let itemsWidth = [].reduce.call(navItems, (width, i) => { return i.clientWidth + width; }, 0);
        let availableWidth = this.sportsNavContainer.clientWidth - itemsWidth;
        let moreNavItemWidth = this.jsTabletOverflowNav.clientWidth + 30; // extend a bit

        // if there is not enough place to fit all nav items
        // then move two last elements of navItems into #js-tablet-overflow > .sub-menu
        let jsTabletOverflowSubMenu = this.jsTabletOverflowNav.querySelector('.sub-menu');
        let topLevelMenu = this.sportsNavContainer.querySelector('#sports-nav .top-level');

        if (jsTabletOverflowSubMenu && topLevelMenu) {
            let navNodesToMove = [
                this.sportsNavTopItems[this.sportsNavTopItems.length - 2],
                this.sportsNavTopItems[this.sportsNavTopItems.length - 1]
            ];

            if (!this.isNavNodesMoved && availableWidth < moreNavItemWidth) {
                this.movedNavNodesWidth = navNodesToMove[0].clientWidth + navNodesToMove[1].clientWidth;
                jsTabletOverflowSubMenu.insertBefore(navNodesToMove[1], jsTabletOverflowSubMenu.firstChild);
                jsTabletOverflowSubMenu.insertBefore(navNodesToMove[0], jsTabletOverflowSubMenu.firstChild);
                this.isNavNodesMoved = true;
            }

            if (this.isNavNodesMoved && availableWidth >= moreNavItemWidth + this.movedNavNodesWidth) {
                topLevelMenu.insertBefore(navNodesToMove[0], this.jsTabletOverflowNav);
                topLevelMenu.insertBefore(navNodesToMove[1], this.jsTabletOverflowNav);
                this.isNavNodesMoved = false;
            }
        }
    }
}

export default NavGlobal;